import React from "react";
import * as types from "./types";

// eslint-disable-next-line import/no-anonymous-default-export
export default (state, action) => {
	switch (action.type) {
		case types.UPDATE_DATA:
			return {
				...state,
				...action.payload,
				dataUpdating: false,
			};
		case types.UPDATE_DATA_LOADING:
			return {
				...state,
				dataUpdating: action.payload,
			};
		case types.UPDATE_ADDITIONAL_CONDITIONS:
			return {
				...state,
				...action.payload,
				dataUpdating: false,
				additionalConditionsUpdating: false,
			};
		case types.UPDATE_ADDITIONAL_CONDITIONS_LOADING:
			return {
				...state,
				additionalConditionsUpdating: action.payload,
			};
		default:
			return { ...state };
	}
};
